module.exports = __webpack_public_path__ + "media/1x1/eg-2ea321dd.svg";